module.exports = "/_next/static/images/uv-1-4d5a2903e2f954a35d30f2ff618f2610.png";